import MidwayIdentityJavaScriptClient from '@amzn/midway-identity-javascript-client';
import { getAsinMetricsEndpointConfig } from './asin-metrics-endpoint-configs';

export default class MidwayClient {
  asinMetricsClient;

  constructor() {
    const endpointConfigs = getAsinMetricsEndpointConfig();
    this.asinMetricsClient = new MidwayIdentityJavaScriptClient(endpointConfigs);
  }
}


// WEBPACK FOOTER //
// ./src/components/reports/asin_metrics/midway_client.jsx